var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useDependency, useSSOClient, } from '@lucidlink/workspacemanagement';
export const useStartSsoAuthentication = () => {
    _react_refresh_temp_1();
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const { exchangeCode, initializeAuthentication } = useSSOClient();
    const startSsoAuthentication = useCallback(async (ssoParams, loginHint) => {
        await initializeAuthentication({
            clientId: ssoParams.clientId,
            serverUri: ssoParams.openIdConnectUrl,
            redirectUri: `${clientBaseUrl}/sso-landing`,
            loginHint,
        });
    }, [clientBaseUrl, initializeAuthentication]);
    return { startSsoAuthentication, exchangeCode };
};
_react_refresh_temp_1(useStartSsoAuthentication, "7SCFFBf+YoFy3swWca16bj4fCJY=", false, () => [useDependency, useSSOClient]);
